import { render } from "./routerresetpassword.vue?vue&type=template&id=0f038ab0"
import script from "./routerresetpassword.vue?vue&type=script&lang=js"
export * from "./routerresetpassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__